import { useEffect, useState } from 'react';
import { titanApi } from '../lib/api';

export type EquitiesModeStatus = {
  equities_only: boolean;
  execution_focus_ui: boolean;
  rt_pattern_eval_enabled: boolean;
  max_live_patterns: number;
  api_worker_mode: string;
  controller_allowed_on_process: boolean;
  read_only_api_process: boolean;
};

const DEFAULTS: EquitiesModeStatus = {
  equities_only: false,
  execution_focus_ui: false,
  rt_pattern_eval_enabled: true,
  max_live_patterns: 50,
  api_worker_mode: 'all',
  controller_allowed_on_process: true,
  read_only_api_process: false,
};

let cached: EquitiesModeStatus | null = null;

export function useEquitiesMode(): EquitiesModeStatus {
  const [mode, setMode] = useState<EquitiesModeStatus>(cached ?? DEFAULTS);

  useEffect(() => {
    let cancelled = false;
    titanApi
      .equitiesMode()
      .then((res) => {
        if (cancelled) return;
        cached = res;
        setMode(res);
      })
      .catch(() => {
        if (!cancelled) setMode(DEFAULTS);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return mode;
}

/** Slim nav: hide backtest/research tools unless Admin or ?tools=1 */
export function useExecutionFocusNav(): boolean {
  const mode = useEquitiesMode();
  return mode.execution_focus_ui || mode.equities_only;
}
